export type TierType = 'shipping' | 'discount';

type BaseTier = {
  minAmount: number;
  discountPercent: number;
};

type ShippingTier = BaseTier & {
  type: 'shipping';
  discountType?: never;
  discountAmount?: never;
};

type PercentTier = BaseTier & {
  type: 'discount';
  discountType: 'percent';
  discountAmount?: never;
};

type FixedCartTier = BaseTier & {
  type: 'discount';
  discountType: 'fixed_cart';
  discountAmount: number;
};

export type Tier = ShippingTier | PercentTier | FixedCartTier;

export type IconVariant = 'check' | 'dot';

export type MilestoneDisplayConfig = {
  /** Whether this benefit is currently active/applied (Guest can only have one active) */
  active: boolean;
  /** Icon type: 'check' for active or not-achieved, 'dot' for achieved-but-not-active */
  iconVariant: IconVariant;
};
